const taxonomyById = new Map();

export const normaliseTaxonomy = (taxonomy) => {
  if (typeof taxonomy === "string") {
    return taxonomyById.get(taxonomy) || { id: taxonomy };
  }

  const id = taxonomy?.id || taxonomy?.Id || taxonomy?.value;
  if (!id) return null;

  const normalised = {
    ...taxonomy,
    id,
    name: taxonomy?.name || taxonomy?.Name || taxonomy?.displayName || taxonomy?.DisplayName || "",
    fullPath: taxonomy?.fullPath || taxonomy?.FullPath || taxonomy?.fullName || taxonomy?.FullName || taxonomy?.path || taxonomy?.Path || "",
  };

  if (normalised.name || normalised.fullPath) taxonomyById.set(id, normalised);
  return normalised;
};

export const normaliseTaxonomies = (taxonomies) => (
  Array.isArray(taxonomies) ? taxonomies.map(normaliseTaxonomy).filter(Boolean) : []
);

export const taxonomyLabel = (taxonomy) => taxonomy?.name || taxonomy?.fullPath || taxonomy?.id || "";
